module.exports = __webpack_public_path__ + "media/music/drumkit_1-67469ce4.mp3";